// extracted by mini-css-extract-plugin
module.exports = {"no-instances-message":"marketplace-instance-teaser_no-instances-message__RIAMv","marketplace-instances-wrapper":"marketplace-instance-teaser_marketplace-instances-wrapper__p0icL"};